import React from 'react';
import useQuerySearchParams from 'routes/surface/hooks/use-query-search-params';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router';

interface UseNodeSearchParametersOperations {
  setNodeIdToSearchParams(surface: string, node: string): void;
  removeNodeIdFromSearchParams(surface: string, node: string): void;
}

export default function useNodeSearchParams(
  showNodeModal,
): UseNodeSearchParametersOperations {
  const operations = useNodeSearchParamsOperations();

  const { id } = useParams<{ id: string }>();

  const history = useHistory();

  const { findNodeById } = useFindNodeInCache(id);

  const searchParams = useQuerySearchParams();

  const node = searchParams.get('node');

  React.useEffect(() => {
    const surfaceNode = node && findNodeById(node);

    if (surfaceNode) {
      showNodeModal(surfaceNode);

      searchParams.delete('node');

      /*history.replace({
        search: searchParams.toString(),
      });*/
    }
  }, [node]);

  return operations;
}

// eslint-disable-next-line unicorn/prevent-abbreviations
export function useNodeSearchParamsOperations(): UseNodeSearchParametersOperations {
  const history = useHistory();
  const searchParams = useQuerySearchParams();

  function removeNodeIdFromSearchParams(surface: string, nodeId: string): void {
    const node = searchParams.get('node');

    if (node && node === nodeId) {
      searchParams.delete('node');

      history.replace({
        search: searchParams.toString(),
      });
    }
  }

  function setNodeIdToSearchParams(surface: string, node: string): void {
    setTimeout(() => {
      searchParams.set('node', node);
      history.push({
        pathname: '/surface/' + surface,
        search: searchParams.toString(),
      });
    }, 500);
  }

  return { setNodeIdToSearchParams, removeNodeIdFromSearchParams };
}
